import { render, staticRenderFns } from "./audio.vue?vue&type=template&id=2549925e&scoped=true&"
import script from "./audio.vue?vue&type=script&lang=js&"
export * from "./audio.vue?vue&type=script&lang=js&"
import style0 from "./audio.vue?vue&type=style&index=0&id=2549925e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2549925e",
  null
  
)

export default component.exports